<template>
  <div class="animated fadeIn">
    <b-row class="mb-2">
      <b-col>
        <h2>แก้ไขกลุ่ม</h2>
      </b-col>
      <b-col>
        <b-button class="float-right ml-4" variant="primary" @click="save">บันทึก</b-button>
        <b-button class="float-right" @click="goBack" variant="warning">ย้อนกลับ</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="6">
        <b-card>
          <div slot="header">
            <strong>รายละเอียดกลุ่ม</strong>
          </div>
          <MygroupMainForm
            v-bind:updateId="$route.params.groupId"
            @groupProcressed="groupProcressed"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import MygroupMainForm from '../../components/mygroup/MainForm'

export default {
  name: 'DashboardMygroupUpdate',
  components: {
    MygroupMainForm
  },
  mounted () {
    window.analytics.track('group-update-open', {
      groupId: this.$route.params.groupId
    })
  },
  methods: {
    async groupProcressed () {
      await this.$bvModal.msgBoxOk('บันทึกข้อมูลสำเร็จ', this.$getConst('okModalClass'))
      this.$router.push({ name: 'กลุ่มทั้งหมด' })
      window.analytics.track('group-update-submitted', {
        groupId: this.$route.params.groupId
      })
    },
    goBack () {
      this.$router.push({
        name: 'กลุ่มทั้งหมด'
      })
    },
    save () {
      Window.Event.$emit('saveGroupForm')
      window.analytics.track('group-update-submit', {
        groupId: this.$route.params.groupId
      })
    }
  }
}
</script>
